import { useEffect, useRef, useState } from 'react'
import type { PanDragState } from '../types/pan-drag-state'

/**
 * Pan mode flags: Space held (temporary hand tool) and a pan drag in progress, plus whether any
 * pan interaction is active (hand tool or Space), and the in-progress pan drag's refs (its start
 * snapshot, the pending scroll target and its animation frame). The pan handlers live in
 * `use-canvas-pan`.
 */
export function useCanvasPanState({ isPanModeActive }: { isPanModeActive: boolean }) {
  const [isSpacePanActive, setIsSpacePanActive] = useState(false)
  const [isDragPanning, setIsDragPanning] = useState(false)
  const isPanModeActiveRef = useRef(isPanModeActive)

  useEffect(() => {
    isPanModeActiveRef.current = isPanModeActive
  }, [isPanModeActive])

  const isPanInteractionActive = isPanModeActive || isSpacePanActive

  const panDragRef = useRef<PanDragState | null>(null)
  const panFrameRef = useRef<number | null>(null)
  const panScrollTargetRef = useRef<{ left: number; top: number } | null>(null)

  return {
    setIsSpacePanActive,
    isDragPanning,
    setIsDragPanning,
    isPanInteractionActive,
    panDragRef,
    panFrameRef,
    panScrollTargetRef,
  }
}
